if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('change', e=>{
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', (e)=>{
					
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}

					const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
					const productFigures = this.querySelectorAll('.apply-gallery-animation');
					this.productSlider.addEventListener('scroll', ()=>{
						const scrollX = -this.productSlider.element.scrollLeft;
						productSlides.forEach((slide,i)=>{
							const media = productFigures[i];
							if ( media ) {
								media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
							}
						});
					});

				});

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && ( KROWN.settings.cart_action == 'overlay' || KROWN.settings.cart_action == 'popup' ) ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
							window.lastFocusedElm = this.querySelector('[data-js-product-add-to-cart]');
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
								addToCartEnter = false;
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}


			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});
			}

		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {
				
				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							window.scrollTo({
								top: variantImg.offsetTop,
								behavior: 'smooth'
							});
						}
					}
				}

			}
			
		}

	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}
/* ── PDP v2 enhancements (rolled out 100% – 2026-05-13) ─────────────────── */
(function () {
  function enhanceUspBox(uspBox) {
    if (!uspBox || uspBox.dataset.abtUspEnhanced === '1') return;

    var content = uspBox.querySelector('.card-widget__content');
    if (!content) return;

    var sourceText = (content.textContent || '').replace(/\s+/g, ' ').trim();
    var pointsMatch = sourceText.match(/verdien\s+\d+\s+killer community punten/i);
    var pointsLine = pointsMatch ? pointsMatch[0] : 'Verdien 95 Killer Community punten';

    content.innerHTML =
      '<div class="abt-usp-proof__line"><span class="abt-usp-proof__icon"></span><span><strong>600.000</strong> vrouwen gingen je voor</span></div>' +
      '<div class="abt-usp-proof__line"><span class="abt-usp-proof__icon"></span><span>Binnen 14 dagen <strong>retouren</strong></span></div>' +
      '<div class="abt-usp-proof__line abt-usp-proof__line--klarna"><img class="abt-usp-proof__klarna-img" src="https://cdn.shopify.com/s/files/1/0553/3866/4049/files/klarna-pay-later.BYbG9Au4.svg?v=1753893387" alt="Klarna" aria-hidden="true"><span>Betaal later of <strong>in 3 delen met Klarna</strong></span></div>' +
      '<div class="abt-usp-proof__divider"></div>' +
      '<div class="abt-usp-proof__line"><span class="abt-usp-proof__icon"></span><span><strong>Gratis verzending</strong> vanaf €100,-.</span></div>' +
      '<div class="abt-usp-proof__line"><span class="abt-usp-proof__icon"></span><span>Voor 22:00 besteld, <strong>morgen in huis.</strong></span></div>' +
      '<div class="abt-usp-proof__line abt-usp-proof__line--trust"><span class="abt-usp-proof__tp-stars" aria-label="1 ster"><svg class="abt-usp-proof__tp-star" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2l2.9 6.26L22 9.27l-5 5.14 1.18 7.09L12 18.4l-6.18 3.1L7 14.41 2 9.27l7.1-1.01z" fill="#00b67a"/></svg></span><span><strong>4/5</strong> gewaardeerd &#39;Goed!&#39; op Trustpilot.</span></div>' +
      '<div class="abt-usp-proof__line abt-usp-proof__line--points"><span class="abt-usp-proof__icon"></span><span>' + pointsLine + '</span></div>';

    uspBox.dataset.abtUspEnhanced = '1';
  }

  function moveUpsellBelowUsp() {
    var productTexts = document.querySelectorAll('.main-product .product-text');
    if (!productTexts.length) return;

    productTexts.forEach(function (productText) {
      var uspBox = null;
      var directChildren = productText.querySelectorAll(':scope > *');

      for (var i = 0; i < directChildren.length; i++) {
        if (directChildren[i].classList.contains('card-widget--is-collapsible')) continue;
        var childText = (directChildren[i].textContent || '').toLowerCase();
        if (childText.indexOf('killer community') !== -1 || childText.indexOf('verdien') !== -1) {
          uspBox = directChildren[i];
        }
      }

      if (!uspBox) {
        var uspCandidates = productText.querySelectorAll(
          ':scope > .card-widget:has(.product-labels), :scope > .toggle:has(.product-labels), :scope > .card-widget:has(.text-with-icon), :scope > .toggle:has(.text-with-icon)'
        );
        uspBox = uspCandidates.length ? uspCandidates[uspCandidates.length - 1] : null;
      }

      var upsellBlock = productText.querySelector(
        ':scope > product-recommendations.product-related, :scope > .card-widget:has(.product-related)'
      );

      if (!uspBox || !upsellBlock) return;
      uspBox.classList.add('abt-usp-proof');
      enhanceUspBox(uspBox);
      if (uspBox.nextElementSibling === upsellBlock) return;

      uspBox.insertAdjacentElement('afterend', upsellBlock);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveUpsellBelowUsp);
  } else {
    moveUpsellBelowUsp();
  }

  // Pakket box
  (function () {
    function buildPakketBox() {
      var pakketData = window.__pdpPakketData || null;

      var cards = document.querySelectorAll('.main-product .product-text .card-widget');
      var pakketCard = null;
      for (var i = 0; i < cards.length; i++) {
        var h = cards[i].querySelector('.card-widget__header, .toggle__header');
        if (h && h.textContent.toLowerCase().indexOf('pakket') !== -1) {
          pakketCard = cards[i];
          break;
        }
      }
      if (!pakketCard) return;

      var box = document.createElement('div');
      box.className = 'abt-pakket-box';

      var hdr = document.createElement('div');
      hdr.className = 'abt-pakket-box__header';
      hdr.textContent = 'Inhoud van dit pakket';
      box.appendChild(hdr);

      if (pakketData && pakketData.length) {
        pakketData.forEach(function (item) {
          var row = document.createElement('div');
          row.className = 'abt-pakket-box__item';
          if (item.img) {
            var wrap = document.createElement('div');
            wrap.className = 'abt-pakket-box__img-wrap';
            var img = document.createElement('img');
            img.src = item.img; img.alt = item.naam || ''; img.loading = 'lazy'; img.width = 60; img.height = 60;
            wrap.appendChild(img); row.appendChild(wrap);
          }
          var naam = document.createElement('span');
          naam.className = 'abt-pakket-box__naam';
          naam.textContent = item.naam || '';
          row.appendChild(naam);
          if (item.badge) {
            var badge = document.createElement('span');
            badge.className = 'abt-pakket-box__badge' + (item.gratis ? ' abt-pakket-box__badge--gratis' : '');
            badge.textContent = item.badge;
            row.appendChild(badge);
          }
          box.appendChild(row);
        });
      } else {
        var content = pakketCard.querySelector('.card-widget__content');
        if (content) {
          var lines = content.innerText.trim().split('\n').filter(function (l) { return l.trim(); });
          lines.forEach(function (text) {
            var row = document.createElement('div');
            row.className = 'abt-pakket-box__item';
            var naam = document.createElement('span');
            naam.className = 'abt-pakket-box__naam';
            naam.textContent = text.trim();
            row.appendChild(naam);
            box.appendChild(row);
          });
        }
      }

      pakketCard.parentNode.insertBefore(box, pakketCard);
      pakketCard.style.display = 'none';
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', buildPakketBox);
    } else {
      buildPakketBox();
    }
  })();

  // Overflow arrows for variant pills
  (function () {
    function makeArrow(variant, container, dir) {
      var arrow = variant.querySelector('.abt-variant-arrow--' + dir);
      if (arrow) return arrow;
      arrow = document.createElement('button');
      arrow.type = 'button';
      arrow.className = 'abt-variant-arrow abt-variant-arrow--' + dir;
      arrow.setAttribute('aria-label', dir === 'next' ? 'Meer smaken tonen' : 'Vorige smaken tonen');
      arrow.innerHTML = dir === 'next' ? '›' : '‹';
      arrow.addEventListener('click', function (e) {
        e.preventDefault();
        var max = container.scrollWidth - container.clientWidth;
        var step = Math.max(container.clientWidth * 0.7, 120);
        var target = dir === 'next' ? container.scrollLeft + step : container.scrollLeft - step;
        if (target >= max - 2) target = max;
        if (target <= 2) target = 0;
        container.scrollTo({ left: target, behavior: 'smooth' });
      });
      variant.appendChild(arrow);
      return arrow;
    }

    function updateOverflowArrows() {
      document.querySelectorAll('.product-variants--radio .product-variant').forEach(function (variant) {
        var container = variant.querySelector('.product-variant__container');
        if (!container) return;
        var hasOverflow = container.scrollWidth > container.clientWidth + 2;
        if (hasOverflow) {
          makeArrow(variant, container, 'next');
          makeArrow(variant, container, 'prev');
        }
        // Ruimere tolerantie: de container rust niet op 0 maar op ~5px door padding + scroll-snap
        var tol = 14;
        var atEnd = container.scrollLeft >= container.scrollWidth - container.clientWidth - tol;
        var atStart = container.scrollLeft <= tol;
        variant.classList.toggle('abt-can-next', hasOverflow && !atEnd);
        variant.classList.toggle('abt-can-prev', hasOverflow && !atStart);
      });
    }

    function init() {
      updateOverflowArrows();
      document.querySelectorAll('.product-variants--radio .product-variant__container').forEach(function (container) {
        container.addEventListener('scroll', updateOverflowArrows, { passive: true });
      });
      if (window.ResizeObserver) {
        new ResizeObserver(updateOverflowArrows).observe(document.body);
      } else {
        window.addEventListener('resize', updateOverflowArrows, { passive: true });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
})();

/* ── PDP Info Slider: drag-to-scroll + pijltjes ── */
(function () {
  function initSlider(wrap) {
    if (!wrap || wrap._pdpSliderInited) return;
    wrap._pdpSliderInited = true;

    var section = wrap.closest('.pdp-info-section');
    var prevBtn = section ? section.querySelector('.pdp-info-slider-btn--prev') : null;
    var nextBtn = section ? section.querySelector('.pdp-info-slider-btn--next') : null;

    /* --- drag-to-scroll (desktop) --- */
    var isDragging = false, startX = 0, scrollLeft = 0;

    wrap.addEventListener('mousedown', function (e) {
      isDragging = true;
      startX = e.pageX - wrap.getBoundingClientRect().left;
      scrollLeft = wrap.scrollLeft;
      wrap.classList.add('is-dragging');
    });

    wrap.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      e.preventDefault();
      var x = e.pageX - wrap.getBoundingClientRect().left;
      wrap.scrollLeft = scrollLeft - (x - startX);
    });

    function stopDrag() {
      isDragging = false;
      wrap.classList.remove('is-dragging');
    }
    wrap.addEventListener('mouseup', stopDrag);
    wrap.addEventListener('mouseleave', stopDrag);

    /* klik op een link/knop niet blokkeren na kleine drag */
    wrap.addEventListener('click', function (e) {
      if (Math.abs(wrap.scrollLeft - scrollLeft) > 5) e.preventDefault();
    }, true);

    /* --- pijltjes --- */
    function cardStep() {
      var card = wrap.querySelector('[class*="__card"], [class*="__step"]');
      return card ? card.offsetWidth + 12 : 272;
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      /* Nog verborgen (display:none door A/B-test) → niet uitrekenen, anders
         wordt next onterecht disabled en reageert hij niet op kliks. */
      if (wrap.clientWidth === 0) return;
      var maxScroll = wrap.scrollWidth - wrap.clientWidth;
      prevBtn.disabled = wrap.scrollLeft <= 2;
      nextBtn.disabled = maxScroll <= 2 || wrap.scrollLeft >= maxScroll - 2;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        wrap.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        wrap.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
    }

    wrap.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
    /* Herbereken zodra de sectie zichtbaar wordt (A/B-test toont hem na DOMContentLoaded) */
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(function () { updateArrows(); }).observe(wrap);
    }
  }

  function initAll() {
    document.querySelectorAll(
      '.pdp-info-ingredients__track-wrap, .pdp-info-usage__track-wrap'
    ).forEach(initSlider);
  }

  /* Vang ook elementen die pas later in de DOM verschijnen (A/B-test inject) */
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function () {
      document.querySelectorAll(
        '.pdp-info-ingredients__track-wrap, .pdp-info-usage__track-wrap'
      ).forEach(initSlider);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
